<mat-dialog-content>
    <img [src]="imageUrl"/>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="buttons">
        <button (click)="cancel()" class="cancel">Close</button>
    </div>
</mat-dialog-actions>
